/* Farms directory — renders the grid + detail overlay from the JSON data
   sections/farms.liquid embeds, and drives it with a URL hash
   (#farms/<handle>) so each farm is linkable/bookmarkable and works with
   the browser's back/forward, without needing a real separate page. */
(function () {
  'use strict';

  var grid = document.querySelector('[data-farm-grid]');
  var detail = document.querySelector('[data-farm-detail]');
  var content = document.querySelector('[data-farm-content]');
  if (!grid || !detail || !content) return;

  var dataEl = document.getElementById('farms-data');
  var farms = [];
  try {
    farms = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var byHandle = {};
  farms.forEach(function (f) { byHandle[f.handle] = f; });

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function mapEmbedUrl(lat, lon) {
    var d = 0.35;
    var bbox = [lon - d, lat - d, lon + d, lat + d].join('%2C');
    return 'https://www.openstreetmap.org/export/embed.html?bbox=' + bbox +
      '&layer=mapnik&marker=' + lat + '%2C' + lon;
  }

  function renderGrid() {
    grid.innerHTML = farms.map(function (f) {
      var cover = f.images[0] || '';
      return (
        '<button type="button" class="farm-card" data-farm-open="' + f.handle + '">' +
          '<div class="farm-card__media">' +
            (cover ? '<img src="' + cover + '" alt="' + escapeHtml(f.name) + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="farm-card__body">' +
            '<p class="farm-card__country">' + escapeHtml(f.country) + '</p>' +
            '<h2 class="farm-card__name">' + escapeHtml(f.name) + '</h2>' +
            '<p class="farm-card__region">' + escapeHtml(f.region) + '</p>' +
          '</div>' +
        '</button>'
      );
    }).join('');
  }

  function fact(label, value) {
    if (!value) return '';
    return '<div class="farm-detail__fact"><dt>' + escapeHtml(label) + '</dt><dd>' + escapeHtml(value) + '</dd></div>';
  }

  function renderDetail(f) {
    var gallery = f.images.map(function (src) {
      return '<img src="' + src + '" alt="' + escapeHtml(f.name) + '" loading="lazy">';
    }).join('');

    var facts = [
      fact('Grower', f.grower),
      fact('Variety', f.variety),
      fact('Harvest', f.harvest),
      fact('Altitude', f.altitude),
      fact('Process', f.process),
      fact('Certifications', f.certs),
      fact('Tasting Notes', f.notes)
    ].join('');

    content.innerHTML =
      '<p class="farm-detail__eyebrow">' + escapeHtml(f.country) + '</p>' +
      '<h2 class="farm-detail__title display" id="farm-detail-title">' + escapeHtml(f.name) + '</h2>' +
      '<p class="farm-detail__region">' + escapeHtml(f.region) + '</p>' +
      '<div class="farm-detail__gallery">' + gallery + '</div>' +
      '<div class="farm-detail__grid">' +
        '<div>' +
          '<dl class="farm-detail__facts">' + facts + '</dl>' +
          '<div class="farm-detail__story rte">' + f.story_html + '</div>' +
        '</div>' +
        '<div class="farm-detail__map">' +
          '<iframe src="' + mapEmbedUrl(f.lat, f.lon) + '" loading="lazy" title="Map of ' + escapeHtml(f.region) + '"></iframe>' +
        '</div>' +
      '</div>';
  }

  var lastFocused = null;

  function openFarm(handle, pushHash) {
    var f = byHandle[handle];
    if (!f) return;
    renderDetail(f);
    lastFocused = document.activeElement;
    detail.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = detail.querySelector('[data-farm-close]:not(.farm-detail__overlay)');
    if (closeBtn) closeBtn.focus();
    if (pushHash !== false && window.location.hash !== '#farms/' + handle) {
      history.pushState(null, '', '#farms/' + handle);
    }
  }

  function closeFarm(pushHash) {
    detail.hidden = true;
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    if (pushHash !== false && window.location.hash.indexOf('#farms/') === 0) {
      history.pushState(null, '', window.location.pathname + window.location.search);
    }
  }

  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-farm-open]');
    if (!btn) return;
    openFarm(btn.getAttribute('data-farm-open'));
  });

  detail.addEventListener('click', function (e) {
    if (e.target.closest('[data-farm-close]')) closeFarm();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !detail.hidden) closeFarm();
  });

  window.addEventListener('popstate', function () {
    var m = window.location.hash.match(/^#farms\/(.+)$/);
    if (m && byHandle[m[1]]) {
      openFarm(m[1], false);
    } else if (!detail.hidden) {
      closeFarm(false);
    }
  });

  renderGrid();

  var initial = window.location.hash.match(/^#farms\/(.+)$/);
  if (initial && byHandle[initial[1]]) {
    openFarm(initial[1], false);
  }
})();
